module.exports = __webpack_public_path__ + "img/light-Creative-demo.d75e4a0e.png";